import { useState } from "react";
import { Box, useTheme } from "@mui/material";
import { AdminPanelContainer } from "../../components/admin-panel/admin-panel-container";
import AdminLoginScreen from "./admin-login-screen";
import { AdminCreds } from "../../types";

const AdminPanel = () => {
  const theme = useTheme();
  const [adminCreds, setAdminCreds] = useState<AdminCreds | null>(null);

  if (!adminCreds) {
    return (
      <AdminLoginScreen
        onAdminLogin={(adminCreds: AdminCreds) => setAdminCreds(adminCreds)}
      />
    );
  }

  return (
    <Box
      className="full-screen flex flex-col items-center relative"
      sx={{
        background: theme.palette.adminPanel.mainBg,
        overflow: "hidden",
      }}
    >
      <AdminPanelContainer adminCreds={adminCreds} />
    </Box>
  );
};

export default AdminPanel;
